import React from 'react';
import { Check, DollarSign } from 'lucide-react';

const ServiceCard = ({ service, isSelected, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={`w-full text-left p-5 rounded-lg border-2 transition-all duration-200 ${
        isSelected
          ? 'border-[#059669] bg-[#059669]/10'
          : 'border-gray-800 bg-[#111827] hover:border-gray-600'
      }`}
      data-testid={`service-card-${service.id}`}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <h3 className="text-white font-semibold text-lg mb-1">{service.name}</h3>
          <p className="text-gray-400 text-sm mb-3">{service.description}</p>
          
          <div className="flex items-center gap-2">
            <span className="text-[#059669] font-bold text-xl">${service.fee}</span>
            {service.hasStateFee && (
              <span className="text-gray-400 text-sm">+ state fee</span>
            )}
            {service.recurring && (
              <span className="text-gray-500 text-xs">/{service.recurring}</span>
            )}
          </div>
        </div>

        {/* Selection Indicator */}
        <div
          className={`w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 ml-4 ${
            isSelected
              ? 'border-[#059669] bg-[#059669]'
              : 'border-gray-600 bg-transparent'
          }`}
        >
          {isSelected && <Check className="w-4 h-4 text-gray-900" />}
        </div>
      </div>
    </button>
  );
};

export default ServiceCard;
